import React, { useEffect, useState } from 'react';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
import { ENABLE_ROADMAP } from '../../config/constants';
import { useAuth } from '../../contexts/AuthContext';

const {
  FiHome,
  FiInbox,
  FiPlus,
  FiTrello,
  FiMoreHorizontal,
  FiMap,
  FiHelpCircle,
  FiShield,
  FiSettings,
  FiLogOut,
  FiX,
} = FiIcons;

const MobileBottomNavigation = ({ activeView, onViewChange, onCreate, onLogout }) => {
  const { isAdmin } = useAuth();
  const [moreOpen, setMoreOpen] = useState(false);

  useEffect(() => {
    if (!moreOpen) return undefined;
    const onKeyDown = (event) => {
      if (event.key === 'Escape') setMoreOpen(false);
    };
    window.addEventListener('keydown', onKeyDown);
    return () => window.removeEventListener('keydown', onKeyDown);
  }, [moreOpen]);

  const go = (view) => {
    setMoreOpen(false);
    onViewChange(view);
  };

  const moreItems = [
    ...(ENABLE_ROADMAP ? [{ id: 'roadmap', label: 'Roadmap', icon: FiMap }] : []),
    { id: 'help', label: 'Help Center', icon: FiHelpCircle },
    ...(isAdmin ? [{ id: 'admin', label: 'Admin', icon: FiShield }] : []),
    { id: 'settings', label: 'Settings', icon: FiSettings },
  ];
  const moreActive = moreItems.some((item) => item.id === activeView);

  return (
    <>
      <nav className="mobile-bottom-nav" aria-label="Primary mobile navigation">
        <NavItem active={activeView === 'dashboard'} icon={FiHome} label="Dashboard" onClick={() => go('dashboard')} />
        <NavItem active={activeView === 'inbox'} icon={FiInbox} label="Inbox" onClick={() => go('inbox')} />
        <button type="button" className="mobile-create-nav" onClick={onCreate} aria-label="Create ticket or app">
          <span className="mobile-create-nav-icon"><SafeIcon icon={FiPlus} className="w-7 h-7" /></span>
          <span>Create</span>
        </button>
        <NavItem active={activeView === 'kanban'} icon={FiTrello} label="Kanban" onClick={() => go('kanban')} />
        <NavItem active={moreActive} icon={FiMoreHorizontal} label="More" onClick={() => setMoreOpen(true)} />
      </nav>

      {moreOpen && (
        <div className="mobile-more-overlay" onMouseDown={(event) => { if (event.target === event.currentTarget) setMoreOpen(false); }}>
          <section className="mobile-more-sheet" role="dialog" aria-modal="true" aria-label="More navigation options">
            <div className="mobile-more-handle" />
            <div className="flex items-center justify-between px-5 pb-3">
              <div>
                <p className="text-xs font-semibold uppercase tracking-wide text-muted">Navigation</p>
                <h2 className="text-lg font-bold text-text">More</h2>
              </div>
              <button type="button" onClick={() => setMoreOpen(false)} className="mobile-sheet-close" aria-label="Close more menu"><SafeIcon icon={FiX} className="w-5 h-5" /></button>
            </div>
            <div className="px-4 pb-3 space-y-1">
              {moreItems.map((item) => (
                <button key={item.id} type="button" onClick={() => go(item.id)} className={`mobile-more-item ${activeView === item.id ? 'mobile-more-item-active' : ''}`}>
                  <SafeIcon icon={item.icon} className="w-6 h-6" />
                  <span>{item.label}</span>
                </button>
              ))}
              <button type="button" onClick={() => { setMoreOpen(false); onLogout(); }} className="mobile-more-item">
                <SafeIcon icon={FiLogOut} className="w-6 h-6" />
                <span>Logout</span>
              </button>
            </div>
          </section>
        </div>
      )}
    </>
  );
};

const NavItem = ({ active, icon, label, onClick }) => (
  <button type="button" onClick={onClick} className={`mobile-nav-item ${active ? 'mobile-nav-item-active' : ''}`}>
    <SafeIcon icon={icon} className="mobile-nav-icon" />
    <span>{label}</span>
  </button>
);

export default MobileBottomNavigation;